/**
 * Created by jonas on 2021-11-23.
 */

import {gsap} from "gsap";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {KitchenDramaSushiManiaGameMode} from "../server/KitchenDramaSushiManiaGameMode";
import {SimplePresentation, SimplePresentationRunnerController} from "../winpresentation/SimplePresentationRunner";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class ExitFreespinPresentation implements SimplePresentation {

    name:string = "ExitFreespinPresentation";

    constructor() {}

    shouldRun():boolean {
        return KitchenDramaSushiMania.model.data.mode == KitchenDramaSushiManiaGameMode.WILD_SUSHI && KitchenDramaSushiMania.model.data.nextMode == KitchenDramaSushiManiaGameMode.NORMAL;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(()=>SlotGame.keypadPlugin.setZeroBetSpinCounter(-1));
        tl.add(KitchenDramaSushiMania.transitionScreen.show(0.001, false));
        tl.add(KitchenDramaSushiMania.transitionScreen.getOutro());
        tl.add(KitchenDramaSushiMania.winView.getWinCountUp(0, KitchenDramaSushiMania.model.gameData.totalRoundWin, 2, new PIXI.Point(360,350),true),">-0.5");

        tl.add(() => {
            this.setupFsReels();
            this.setupFsViews();
            KitchenDramaSushiMania.backgroundElements.setMode(KitchenDramaSushiMania.model.data.nextMode);
            KitchenDramaSushiMania.soundPlayer.switchMusic(KitchenDramaSushiMania.model.data.nextMode, 0);
            KitchenDramaSushiMania.soundPlayer.fadeInMusic(1500);

        });
        tl.add(KitchenDramaSushiMania.transitionScreen.enableButton(() => this.onButtonClick(controller)));
    }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(KitchenDramaSushiMania.transitionScreen.hide(0.3), "<");
        tl.add(KitchenDramaSushiMania.winView.getWinCountUpFade(KitchenDramaSushiMania.model.gameData.totalRoundWin));
        tl.add(() => controller.finish());
    }

    private setupFsReels() {
        //TODO Change reel set maybe?
    }

    private setupFsViews() {
        KitchenDramaSushiMania.kamisabiCollectView.show();
        KitchenDramaSushiMania.sushiCollectView.show();
        KitchenDramaSushiMania.sushiFsMeterView.hide();
    }

}